import { clsx } from 'clsx';

import { MAP_STORYBLOK_BACKGROUNDS_TO_TAILWIND } from '@monoimin/constants';

import type { TailwindBackgroundVariants } from '@monoimin/sb-types';

/**
 *  Eсли значение backround !== white то поставляется вертикальный отступ (py-24), так прописано в дизайн системе
 */
export const getBackground = (background = ''): string => {
  const isBackground: TailwindBackgroundVariants | undefined =
    MAP_STORYBLOK_BACKGROUNDS_TO_TAILWIND[background];

  return clsx(isBackground, isBackground && 'py-12 lg:py-24');
};

export default getBackground;
